import { Container, Sprite } from 'pixi.js'

import ParticleSystem from "./ParticleSystem"
const { floor } = Math

export default class RocketStage extends Container {

    constructor(texture, resolution) {
        super();

        const spriteRatio = texture.orig.width / texture.orig.height
        const spriteHeight = texture.orig.height / resolution
        const spriteWidth = floor(spriteHeight * spriteRatio)

        const sprite = new Sprite(texture)
        sprite.anchor.set(0.5, 1)
        sprite.width = spriteWidth
        sprite.height = spriteHeight


        const separationParticles = new ParticleSystem("separationThruster", ["particles/particle"])
        separationParticles.y = -10
        this.addChild(separationParticles)
        this.separation = separationParticles

        const thrusterParticles = new ParticleSystem("stageThruster", ["particles/particle"])
        thrusterParticles.y = -10
        this.addChild(thrusterParticles)
        this.thruster = thrusterParticles

        this.addChild(sprite)
    }

    setPosition(properties) {
        this.x = properties.x || this.x || 0
        this.y = properties.y || this.y || 0
    }

    startThruster() {
        this.thruster.start()
    }

    stopThruster() {
        this.thruster.stop()
    }

    dettachLowerStage() {
        this.separation.start()
    }
}
